/* eslint-disable no-unused-vars */
import React from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { clearGetState } from "../actionsMethods/masterMethods";

import back_img from "../assests/images/rightVector.svg";
import right_arrow_white from "../assests/images/right-arrow-white.png";
import envUrls from "../config/env-urls";

const REACT_APP_ENV = process.env.REACT_APP_ENV || "dev";
const reportBaseURL = envUrls[REACT_APP_ENV].API.reportBaseURL;

const Heading = ({
  title,
  navigateTo,
  id,
  nextPage,
  nextPageTitle,
  imgSrc,
  buttonClick,
  shipmentScanning,
  children,
  showBack = true,
  goBack: goBackProp,
  newReportUrl,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const goBack = () => {
    if (navigateTo) {
      if (typeof navigateTo === "string") {
        navigate(navigateTo, { state: id });
      } else if (typeof navigateTo === "object") {
        const { pathname, search, state } = navigateTo;
        navigate({ pathname, search }, { state });
      }
    } else {
      if (title === "Client List") {
        localStorage.removeItem("clientId");
      }
      navigate(-1);
      dispatch(clearGetState());
    }
  };
  const nextButtonClick = () => {
    if (buttonClick) {
      buttonClick();
    } else {
      navigate(nextPage);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "8px",
      }}
    >
      {/* Left: Back arrow + Title + New Report Button immediately after */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap", marginBottom: "5px" }}>
        <p className="master-title-head" style={{ marginBottom: 0 }}>
          {showBack && (
            <img
              src={back_img}
              onClick={goBackProp ? goBackProp : goBack}
              className="pointer"
            />
          )}
          <span>{title}</span>
        </p>

        {newReportUrl && (
          <a
            href={newReportUrl.startsWith("http") ? newReportUrl : `${reportBaseURL}${newReportUrl}`}
            target="_blank"
            rel="noopener noreferrer"
            className="new-portal-link"
          >
            New ✨
          </a>
        )}
      </div>

      {/* Right side: shipmentScanning â†’ nextPage btn â†’ timestamps (children) */}
      <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
        {shipmentScanning}
        {nextPageTitle && (
          <button className="next-btn" onClick={nextButtonClick}>
            {imgSrc && (
              <img src={imgSrc} style={{ height: "18px", width: "18px" }} />
            )}
            &nbsp;&nbsp;{nextPageTitle}&nbsp;
            {imgSrc && (
              <img
                src={right_arrow_white}
                className="pointer"
                style={{ height: "12px", width: "12px" }}
              />
            )}
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Heading;
